import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ZendeskService } from '@mkp/shared/util-zendesk';

@Component({
  selector: 'ui-gdpr-zendesk-placeholder',
  templateUrl: './gdpr-zendesk-placeholder.template.html',
  styleUrl: './gdpr-zendesk-placeholder.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GdprZendeskPlaceholderComponent {
  readonly zendeskService = inject(ZendeskService);

  openModal() {
    this.zendeskService.openWidget();
  }
}
